module.exports = __webpack_public_path__ + "img/playstation.556f6237.png";